import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ErreurComponent } from './core/components/erreur/erreur.component';
import { IndisponibleComponent } from './core/components/indisponible/indisponible.component';
import { ErreurCaisseNonEligibleComponent } from './core/components/erreur-caisse-non-eligible/erreur-caisse-non-eligible.component';
import { FeatureInactiveComponent } from './core/components/feature-inactive/feature-inactive.component';
import { PageNonAuthentifieComponent } from './core/components/page-non-authentifie/page-non-authentifie.component';

export enum RouteEnum {
  Erreur = 'erreur',
  Maintenance = 'indisponible',
  FeatureInactive = 'feature-inactive',
  NonEligible = 'message',
  NonAuthentifie = 'non-authentifie'
}

export const COMMON_ROUTES = [
  {
    path: RouteEnum.Erreur,
    component: ErreurComponent
  },
  {
    path: RouteEnum.Maintenance,
    component: IndisponibleComponent
  },
  {
    path: RouteEnum.FeatureInactive,
    component: FeatureInactiveComponent
  },
  {
    path: RouteEnum.NonEligible,
    component: ErreurCaisseNonEligibleComponent
  },
  {
    path: RouteEnum.NonAuthentifie,
    component: PageNonAuthentifieComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(COMMON_ROUTES, { initialNavigation: 'disabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
